<script setup lang="ts">
import { computed } from 'vue';
import ItemList from '@/components/menu/common/item-list.vue';
import SectionWrapper from '@/components/menu/sections/section-wrapper.vue';
import { useTeamInfo } from '@/utils/swr';

type ItemListProps = InstanceType<typeof ItemList>['$props'];
type ItemsProps = ItemListProps['items'];

const { data: teamInfo } = useTeamInfo();

const mediaTypeSelectionEnabled = computed(
  () => teamInfo.value?.enable_foreign_lang_media,
);

const items = computed<ItemsProps>(() => {
  const result: ItemsProps = [
    {
      id: 'organizationTags',
      name: '組織タグ',
      route: { name: 'settingsOrganizationTags' },
    },
  ];
  if (mediaTypeSelectionEnabled.value) {
    result.push({
      id: 'mediaDisplay',
      name: 'メディアの表示設定',
      route: {
        name: 'settingsMediaDisplay',
      },
    });
  }
  return result;
});
</script>
<template>
  <SectionWrapper>
    <ItemList title="設定" :items="items" />
  </SectionWrapper>
</template>
<style scoped lang="scss"></style>
